import React from 'react';
import ProgressiveImage from 'components/ProgressiveImage';

import './ImageCard.scss';

const ImageCard = props => {
	const {
		children,
		body,
		image,
		imageElement,
		title,
		className,
		responsive,
		onClick,
		style = {},
	} = props;
	const responsiveClass = responsive ? 'responsive' : '';
	return (
		<div
			className={`ImageCard ${className} ${responsiveClass}`}
			{...(onClick && { onClick: () => onClick() })}
			style={style}
		>
			<div className="card-image">
				{image && <ProgressiveImage src={image} alt={title || image} />}
				{imageElement}
			</div>
			{title && <div className="card-title">{title}</div>}
			{body || children}
		</div>
	);
};

export default ImageCard;
